(function () {
  const INITIAL_VISIBLE = 3;

  function initEnrichedGallery(root = document) {
    const products = root.querySelectorAll('[id^="MainProduct-"]');

    products.forEach((productSection) => {
      const gallery = productSection.querySelector('.product__media-list');

      if (!gallery) return;
      if (gallery.dataset.efGalleryReady === 'true') return;

      const items = Array.from(
        gallery.querySelectorAll('.product__media-item')
      );

      if (items.length <= INITIAL_VISIBLE) return;

      gallery.dataset.efGalleryReady = 'true';

      let expanded = false;

      function updateGallery() {
        items.forEach((item, index) => {
          if (expanded || index < INITIAL_VISIBLE) {
            item.classList.remove('ef-gallery-hidden');
          } else {
            item.classList.add('ef-gallery-hidden');
          }
        });

        buttonText.textContent = expanded
          ? 'Close images'
          : 'View all images';

        arrow.textContent = expanded ? '↑' : '↓';
      }

      const controls = document.createElement('div');
      controls.className = 'ef-gallery-more';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ef-gallery-more__button';

      const buttonText = document.createElement('span');
      const arrow = document.createElement('span');

      button.appendChild(buttonText);
      button.appendChild(arrow);

      controls.appendChild(button);

      gallery.insertAdjacentElement('afterend', controls);

      button.addEventListener('click', function () {
        expanded = !expanded;

        updateGallery();

        if (!expanded) {
          gallery.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });

      updateGallery();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initEnrichedGallery();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initEnrichedGallery(event.target);
  });
})();